





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Wearable } from '@/backend/type';
import { bgShadowMap } from '@/utils/color';
import { alpaUnit } from '@/utils/unit';
import BigNumber from 'bignumber.js';
import { getAlpaca } from '@/utils/web3';

@Component
export default class WearableCard extends Vue {
  @Prop({
    required: true,
  })
  public wearable!: Wearable;

  @Prop({
    required: false,
    default: true,
  })
  public hasInfo!: boolean;

  @Prop({
    required: false,
    default: false,
  })
  public hasState!: boolean;

  @Prop({
    required: false,
    default: false,
  })
  public hasShadow!: boolean;

  @Prop({
    required: false,
    default: false,
  })
  public hasSelect!: boolean;

  @Prop({
    required: false,
    default: false,
  })
  public selected!: boolean;

  @Prop({
    required: false,
    default: false,
  })
  public isFarmer!: boolean;

  get bgColor() {
    return this.wearable.card_background_color;
  }

  get shadowColor() {
    return bgShadowMap.get(this.bgColor) || '#82C4B4';
  }
}
